import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import session from '@/models/v5/session';
import Accounts from '@/collections/v5/accounts';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-invalid-session.hbs';

var InvalidSessionDialog = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        alert: '.modal-alert-container > .alert',
        alertContainer: '.modal-alert-container',
        password: 'input[type="password"]',
        loginButton: 'button[type="submit"]'
    },
    events: {
        'submit form': 'loginSubmit'
    },
    initialize: function(options) {
        // DialogInterface methods
        this.destroyOnClose();
        this.focusFirstInput();
    },
    onRender: function() {
        // Hide any error popups generated by the failed request
        Radio.request('alerts', 'hideAlert');
    },
    loginSubmit: function(e) {
        e.preventDefault();
        this.hideAlert();
        var user = Accounts.me();
        var id = user.get('username');
        var password = this.ui.password.val();

        session.login(id, password)
            .done(session.save)
            .done((function(response) {
                this.closeDialog();
                Radio.request('global', 'fetchEverything');
                Radio.request('global', 'home');
            }).bind(this))
            .fail((function(model, response) {
                var defaultErrorMsg = 'An error occurred, please try again.';
                this.showAlert('error', defaultErrorMsg);
            }).bind(this))
        ;
    }
});
export default InvalidSessionDialog;
